import { BaseAction, actionTypes } from 'redux/actions';
import { locale } from 'redux/reducers/components/resources.reducer';

export const setLanguageAction = (lng: string): BaseAction => ({
  type: actionTypes.RESOURCES.SET_LANGUAGE,
  payload: lng
});

export const setAvailOptionsAction = (availOptions: { value: string, text: string }[]): BaseAction => ({
  type: actionTypes.RESOURCES.SET_AVAIL_OPTIONS,
  payload: availOptions
});

export const fetchResourcesAction = (): BaseAction => ({
  type: actionTypes.RESOURCES.FETCH_RESOURCES
});

export const addLocaleAction = (data: locale): BaseAction => ({
  type: actionTypes.RESOURCES.ADD_LOCALE,
  payload: data
});
